export interface SellingType {
  id: string;
  name: string;
  color: string;
  inventoryFieldIds: (string | number)[];
  trackInventory: boolean;
  itemLabel: string;
  identifierField: string;
  availableStatus: string;
  soldStatus: string;
  progressLabel: string;
}

export const defaultSellingTypes: SellingType[] = [
  {
    id: "11111111-1111-4111-a111-111111111111", name: "Residential Property", color: "indigo",
    inventoryFieldIds: ["aaaaaaaa-1111-4aaa-aaaa-111111111111", "aaaaaaaa-2222-4aaa-aaaa-222222222222", "aaaaaaaa-3333-4aaa-aaaa-333333333333", "aaaaaaaa-4444-4aaa-aaaa-444444444444", "aaaaaaaa-5555-4aaa-aaaa-555555555555", "aaaaaaaa-6666-4aaa-aaaa-666666666666", "aaaaaaaa-7777-4aaa-aaaa-777777777777"],
    trackInventory: true, itemLabel: "Unit", identifierField: "Unit Number",
    availableStatus: "Available", soldStatus: "Sold", progressLabel: "Units sold",
  },
  {
    id: "22222222-2222-4222-a222-222222222222", name: "Commercial Property", color: "amber",
    inventoryFieldIds: ["aaaaaaaa-1111-4aaa-aaaa-111111111111", "aaaaaaaa-2222-4aaa-aaaa-222222222222", "aaaaaaaa-5555-4aaa-aaaa-555555555555", "aaaaaaaa-6666-4aaa-aaaa-666666666666"],
    trackInventory: true, itemLabel: "Unit", identifierField: "Unit Number",
    availableStatus: "Available", soldStatus: "Sold", progressLabel: "Units sold",
  },
  {
    id: "33333333-3333-4333-a333-333333333333", name: "Plot / Land", color: "green",
    inventoryFieldIds: ["aaaaaaaa-1111-4aaa-aaaa-111111111111", "aaaaaaaa-4444-4aaa-aaaa-444444444444", "aaaaaaaa-5555-4aaa-aaaa-555555555555", "aaaaaaaa-6666-4aaa-aaaa-666666666666"],
    trackInventory: true, itemLabel: "Plot", identifierField: "Unit Number",
    availableStatus: "Available", soldStatus: "Sold", progressLabel: "Plots sold",
  },
  {
    id: "44444444-4444-4444-a444-444444444444", name: "Courses & Batches", color: "amber",
    inventoryFieldIds: ["aaaaaaaa-1111-4aaa-aaaa-111111111111", "aaaaaaaa-2222-4aaa-aaaa-222222222222", "aaaaaaaa-5555-4aaa-aaaa-555555555555", "aaaaaaaa-6666-4aaa-aaaa-666666666666"],
    trackInventory: true, itemLabel: "Seat", identifierField: "Unit Number",
    availableStatus: "Available", soldStatus: "Enrolled", progressLabel: "Seats filled",
  },
  {
    id: "55555555-5555-4555-a555-555555555555", name: "Products", color: "green",
    inventoryFieldIds: ["aaaaaaaa-1111-4aaa-aaaa-111111111111", "aaaaaaaa-2222-4aaa-aaaa-222222222222", "aaaaaaaa-5555-4aaa-aaaa-555555555555", "aaaaaaaa-6666-4aaa-aaaa-666666666666"],
    trackInventory: true, itemLabel: "Product", identifierField: "Unit Number",
    availableStatus: "In Stock", soldStatus: "Out of Stock", progressLabel: "Stock status",
  },
  {
    id: "66666666-6666-4666-a666-666666666666", name: "Packages & Services", color: "pink",
    inventoryFieldIds: ["aaaaaaaa-1111-4aaa-aaaa-111111111111", "aaaaaaaa-4444-4aaa-aaaa-444444444444", "aaaaaaaa-5555-4aaa-aaaa-555555555555", "aaaaaaaa-6666-4aaa-aaaa-666666666666"],
    trackInventory: true, itemLabel: "Slot", identifierField: "Unit Number",
    availableStatus: "Available", soldStatus: "Booked", progressLabel: "Slots booked",
  },
  {
    id: "77777777-7777-4777-a777-777777777777", name: "Plans & Licenses", color: "purple",
    inventoryFieldIds: ["aaaaaaaa-1111-4aaa-aaaa-111111111111", "aaaaaaaa-5555-4aaa-aaaa-555555555555", "aaaaaaaa-6666-4aaa-aaaa-666666666666"],
    trackInventory: true, itemLabel: "Plan", identifierField: "Unit Number",
    availableStatus: "Active", soldStatus: "Active Clients", progressLabel: "Client adoption",
  },
  {
    id: "88888888-8888-4888-a888-888888888888", name: "Custom", color: "teal",
    inventoryFieldIds: ["aaaaaaaa-1111-4aaa-aaaa-111111111111", "aaaaaaaa-4444-4aaa-aaaa-444444444444", "aaaaaaaa-5555-4aaa-aaaa-555555555555", "aaaaaaaa-6666-4aaa-aaaa-666666666666"],
    trackInventory: true, itemLabel: "Service", identifierField: "Unit Number",
    availableStatus: "Available", soldStatus: "Booked", progressLabel: "Services booked",
  },
];

export const sellingTypeColorOptions = [
  "indigo",
  "green",
  "amber",
  "red",
  "purple",
  "pink",
  "teal",
  "orange",
];

export function getSellingTypeColorClass(color: string): string {
  const map: Record<string, string> = {
    indigo: "bg-indigo-500",
    green: "bg-green-500",
    amber: "bg-amber-500",
    red: "bg-red-500",
    purple: "bg-purple-500",
    pink: "bg-pink-500",
    teal: "bg-teal-500",
    orange: "bg-orange-500",
  };
  return map[color] || "bg-indigo-500";
}

export function getSellingTypeBgClass(color: string): string {
  const map: Record<string, string> = {
    indigo: "bg-indigo-50 text-indigo-700",
    green: "bg-green-50 text-green-700",
    amber: "bg-amber-50 text-amber-700",
    red: "bg-red-50 text-red-700",
    purple: "bg-purple-50 text-purple-700",
    pink: "bg-pink-50 text-pink-700",
    teal: "bg-teal-50 text-teal-700",
    orange: "bg-orange-50 text-orange-700",
  };
  return map[color] || "bg-indigo-50 text-indigo-700";
}